var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.429 8.96882H13.143V10.8188C13.678 9.75482 15.05 8.79882 17.111 8.79882C21.062 8.79882 22 10.9168 22 14.8028V21.9998H18V15.6878C18 13.4748 17.465 12.2268 16.103 12.2268C14.214 12.2268 13.429 13.5718 13.429 15.6868V21.9998H9.429V8.96882ZM2.57 21.8298H6.57V8.79882H2.57V21.8298ZM7.143 4.54982C7.14315 4.88509 7.07666 5.21705 6.94739 5.5264C6.81812 5.83576 6.62865 6.11633 6.39 6.35182C5.9064 6.83244 5.25181 7.10147 4.57 7.09982C3.88939 7.09936 3.23631 6.83102 2.752 6.35282C2.51421 6.11653 2.32539 5.83564 2.19634 5.52625C2.0673 5.21686 2.00058 4.88504 2 4.54982C2 3.87282 2.27 3.22482 2.753 2.74682C3.23689 2.26798 3.89024 1.99952 4.571 1.99982C5.253 1.99982 5.907 2.26882 6.39 2.74682C6.872 3.22482 7.143 3.87282 7.143 4.54982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.70905bc970b0f4290827d97a17b60094.svg";
export { ForwardRef as ReactComponent };